import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { timeZones, API_CLIENTS_NAME, API_KEY } from '../../utils';

import { clientsSelector, getClientById } from '../../store/slices/clients';
import {
  selectedClientSelector,
  setSelectedClient
} from '../../store/slices/selectedClient';
import { authSelector } from '../../store/slices/auth';

import { getGroups, groupsSelector } from '../../store/slices/groups';
import { postsSelector } from '../../store/slices/posts';
import { unwrapResult } from '@reduxjs/toolkit';
import { useHistory } from 'react-router-dom';

import './Client.scss';
import axios from 'axios';

import UnifiedAboutContent from './UnifiedAboutContent';
import ImageLibrary from './ImageLibrary/ImageLibrary';

import ReviewsSection from './ReviewsSection';

// Function to compare two arrays
function comparer(otherArray) {
  return function (current) {
    return (
      otherArray.filter(function (other) {
        return other.groupName === current.groupName;
      }).length === 0
    );
  };
}

function ClientReviews({ match }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [editClient, setEditClient] = useState(false);
  const [clientDetails, setClientDetails] = useState(null);
  const [saveLoading, setSaveLoading] = useState(false);
  const [editedProps, setEditedProps] = useState(null);
  const [viewSelect, setViewSelect] = useState(1);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectGroupOptions, setSelectGroupOptions] = useState([]);
  const [selectTimeZonesOptions, setSelectTimeZonesOptions] = useState([]);
  const { customerList } = useSelector(clientsSelector);
  const { selectedClient } = useSelector(selectedClientSelector);
  const { loadingPosts } = useSelector(postsSelector);
  const { userInfo } = useSelector(authSelector);
  const { groupsList } = useSelector(groupsSelector);
  const [lastReviews, setLastReviews] = useState([]);
  const [automaticReviews, setAutomaticReviews] = useState(false);

  const standardMergeFields = [
    '~Name',
    '~Address',
    '~City',
    '~Phone',
    '~Website',
    '~BestDish',
    '~BestService',
    '~BestProduct'
  ];
  const btnTagRef = useRef();

  // Styles of search select
  const searchStyle = {
    control: (_, { selectProps: { width } }) => ({
      width: width,
      border: 'none'
    }),
    indicatorsContainer: () => ({
      display: 'none'
    }),
    input: (provided) => ({
      ...provided,
      marginTop: '0.5em'
    })
  };

  const isLoadingRef = useRef(false);
  const currentClientId = useRef(null);

  useEffect(() => {
    async function getURLClient() {
      if (isLoadingRef.current) return;

      isLoadingRef.current = true;

      try {
        const client = await axios.get(
          `${API_CLIENTS_NAME}${match.params.id}`,
          {
            headers: {
              'X-API-KEY': API_KEY,
              Authorization: `bearer ${userInfo.accessToken}`
            }
          }
        );

        if (client.data) {
          if (currentClientId.current !== client.data.id) {
            currentClientId.current = client.data.id;
            dispatch(setSelectedClient(client.data));
          }
        }
      } catch (error) {
        console.error('Error loading client:', error);
      } finally {
        isLoadingRef.current = false;
      }
    }

    getURLClient();
    // eslint-disable-next-line
  }, [match.params.id]);

  const isProcessingDetails = useRef(false);

  useEffect(() => {
    async function loadDetails() {
      if (isProcessingDetails.current) return;
      if (!selectedClient.id) return;
      if (currentClientId.current === selectedClient.id && clientDetails)
        return;

      isProcessingDetails.current = true;

      try {
        let res = await dispatch(
          getClientById({ clientId: selectedClient.id })
        );
        res = unwrapResult(res);
        setAutomaticReviews(res.automaticReviews);
        setClientDetails(res);
      } catch (e) {
        console.error(e);
      } finally {
        isProcessingDetails.current = false;
      }
    }

    if (selectedClient.id) {
      loadDetails();
    }
    // eslint-disable-next-line
  }, [selectedClient]);

  // Set groups dropdown options
  useEffect(() => {
    if (editedProps) {
      var resultA = groupsList.filter(comparer(editedProps.clientGroups));
      resultA = resultA.map((opt) => ({
        value: opt.id,
        label: opt.groupName
      }));
      setSelectGroupOptions(resultA);
    }
    // eslint-disable-next-line
  }, [editedProps, editClient]);

  // Set timezone dropdown options
  useEffect(() => {
    if (editedProps) {
      let listTimeZone;
      if (clientDetails && clientDetails.timeZone) {
        listTimeZone = timeZones
          .filter((item) => item.name !== clientDetails.timeZone)
          .map((zone) => ({
            value: zone.id,
            label: zone.name
          }));
      } else {
        listTimeZone = timeZones.map((zone) => ({
          value: zone.id,
          label: zone.name
        }));
      }
      setSelectTimeZonesOptions(listTimeZone);
    }
    // eslint-disable-next-line
  }, [editedProps, editClient]);

  return (
    <>
      <ReviewsSection />
    </>
  );
}

export default ClientReviews;
